import React, { FC, PropsWithChildren } from "react";
import classnames from "classnames";
import { Form } from "react-bootstrap";

interface Props extends PropsWithChildren {
  name: string;
  required?: boolean;
  valid?: boolean;
  disabled?: boolean;
  isWidget?: boolean;
  keyId?: string;
  isLittle?: boolean;
  inputStyle?: React.CSSProperties;
}

const CustomPropertyInputItem: FC<Props> = ({
  isWidget = false,
  name,
  required = false,
  valid = true,
  disabled = false,
  keyId = name,
  isLittle = false,
  inputStyle,
  children,
}) => {
  const inputClassNames = classnames({
    "input-item": true,
    error: !valid,
    disabled: disabled,
    "input-item--little": isLittle,
  });
  return isWidget ? (
    <Form.Group
      key={"fg" + keyId}
      className={inputClassNames}
      style={inputStyle}
    >
      <Form.Label key={"fl" + keyId} className="input-label">
        {name}
        {required && <i className="input-required">*</i>}
      </Form.Label>
      {children}
    </Form.Group>
  ) : (
    <div key={"input-i" + keyId} className={inputClassNames} style={inputStyle}>
      <label key={"il" + keyId} className="input-label">
        {name}
        {required && <i className="input-required">*</i>}
      </label>
      {children}
    </div>
  );
};

export default CustomPropertyInputItem;
